import * as Leaflet from 'leaflet';
import { HeatmapInstallerState } from '../../helpers/interfaces';
export const initState:HeatmapInstallerState = {
	bounds: null,
	currentMap: "main",
	deleteError: false,
	dragError: false,
	drawedVerticesAmount: 0,
	editedVertexCurrentState: {},
	editedVertexPrevState: null,
	editedVertices: [], //current state
	editedVerticesPrevStates: [], //previous state
	initialState: [], //inital state
	isCancelDrawingButtonClicked: false,
	isFinishDrawingButtonClicked: false,
	isListenersNeeded: true,
	isPointDraggable: false,
	isPolygonEditable: false,
	isPolygonUpdated: false,
	isToolbarActive: true,
	isWaitingForResponse: false,
	map: null,
	mapSavedFailed: false,
	neededRescaling: 0,
	points: [],
	polygons: [], //array with arrays [lat,lng]
	polygonsEdited: false,
	popupOpen: false,
	prevStatePolygons: [],
	scaleFactor: null,
	scrollWheelZoom: false,
	showAllDevices: false,
	showIcons: false,
	toolbarButtons: [],
	transformedPolygons: [],
	updateData: false,
	wHei: 0,
	wWidth: 0,
	zoomArg: null,
};
